import { FormattedMessage } from 'react-intl';

import { useEditContext } from '@xing-com/crate-entity-pages-common';
import { SocialBar } from '@xing-com/crate-social-bar';
import { IconLike, IconShow } from '@xing-com/icons';

import type { ArticleCardView } from '../../../types/types';
import { ICON_DIMENSION } from '../constants';

import {
  IconTextWrapper,
  SocialInfoLeft,
  SocialInfoRight,
  SocialInfoWrapper,
} from './article-card-bottom.styles';

type Props = {
  article: ArticleCardView;
  position?: number;
};

export const ArticleCardBottom: React.FC<Props> = ({ article, position }) => {
  const { isEditing } = useEditContext();

  if (!isEditing && article.urn) {
    return (
      <SocialBar
        data-testid="ARTICLE-CARD-BOTTOM-SOCIAL-BAR"
        urn={article.urn}
        url={article.url}
        hasReaction={true}
        hasShare={true}
        hasComment={true}
        commentTo={article.commentUrl}
        hasViewCounter
        propChannel="wbm/EntityPages"
        backendTrackingMetaData={{
          page: 'entity_pages/overview',
          position: position?.toString(),
        }}
      />
    );
  }

  const reactionsCount = article.socialInteractions.reactionsCount ?? 0;
  const commentsCount = article.socialInteractions.commentsCount ?? 0;
  const sharesCount = article.socialInteractions.sharesCount ?? 0;
  const viewsCount = article.socialInteractions.viewsCount ?? 0;

  const showReactionsCount = reactionsCount > 0 || isEditing;
  const showCommentsCount = commentsCount > 0 || isEditing;
  const showSharesCount = sharesCount > 0 || isEditing;
  const showViewsCount = isEditing;

  return (
    <>
      <SocialInfoWrapper>
        <SocialInfoLeft>
          {showReactionsCount ? (
            <IconTextWrapper>
              <IconLike width={ICON_DIMENSION} height={ICON_DIMENSION} />
              <span data-testid="ARTICLE-CARD-BOTTOM-REACTIONS-COUNT">
                {reactionsCount}
              </span>
            </IconTextWrapper>
          ) : null}
          {showCommentsCount ? (
            <span data-testid="ARTICLE-CARD-BOTTOM-COMMENTS-COUNT">
              <FormattedMessage
                id="EP_ARTICLES_SOCIAL_COMMENTS_COUNTER_LABEL"
                values={{ counter: commentsCount }}
              />
            </span>
          ) : null}
          {showSharesCount ? (
            <span data-testid="ARTICLE-CARD-BOTTOM-SHARES-COUNT">
              <FormattedMessage
                id="EP_ARTICLES_SOCIAL_SHARES_COUNTER_LABEL"
                values={{ counter: sharesCount }}
              />
            </span>
          ) : null}
        </SocialInfoLeft>
        {showViewsCount ? (
          <SocialInfoRight>
            <IconTextWrapper>
              <IconShow width={ICON_DIMENSION} height={ICON_DIMENSION} />
              <span>{viewsCount}</span>
            </IconTextWrapper>
          </SocialInfoRight>
        ) : null}
      </SocialInfoWrapper>
    </>
  );
};
